// Pixel-art title animations, themed per WAD.
// Rendered next to the title in the hero + detail modal.

const anim = (name, dur, extra = {}) => ({
  animation: `${name} ${dur}s steps(1, end) infinite`,
  transformBox: "fill-box",
  ...extra,
});
const smooth = (name, dur, extra = {}) => ({
  animation: `${name} ${dur}s ease-in-out infinite`,
  transformBox: "fill-box",
  ...extra,
});

const Blood = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <rect x="1" y="3" width="14" height="3" fill="#7f1d1d" />
    <rect x="1" y="5" width="14" height="1" fill="#b91c1c" />
    {[2.5, 7, 11.5].map((x) => (
      <rect
        key={x}
        x={x}
        y="6"
        width="2"
        height="3"
        rx="1"
        fill="#ef4444"
        style={smooth("wv-blood-drip", 2.2, { animationDelay: `${x * 0.11}s` })}
      />
    ))}
  </svg>
);

const Alien = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <rect x="4" y="2" width="8" height="7" fill="#84cc16" />
    <rect x="3" y="4" width="10" height="4" fill="#84cc16" />
    <rect x="5" y="9" width="6" height="3" fill="#65a30d" />
    <g style={anim("wv-blink", 3.2)} transform="translate(0,0)">
      <rect x="5" y="5" width="2" height="3" fill="#0a0a0c" />
      <rect x="9" y="5" width="2" height="3" fill="#0a0a0c" />
    </g>
  </svg>
);

const SquareGuy = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <g style={smooth("wv-square-bounce", 1.6, { transformOrigin: "center" })}>
      <rect x="3" y="3" width="10" height="10" rx="1" fill="#f59e0b" />
      <rect x="3" y="3" width="10" height="10" rx="1" fill="none" stroke="#b45309" strokeWidth="0.6" />
      <rect x="5" y="6" width="1.6" height="2.4" fill="#1c1917" />
      <rect x="9.4" y="6" width="1.6" height="2.4" fill="#1c1917" />
      <rect x="5" y="10" width="6" height="1.4" fill="#1c1917" />
    </g>
  </svg>
);

const Flame = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <g style={smooth("wv-flame", 0.9, { transformOrigin: "bottom" })}>
      <path d="M8 1 L11 6 L12 11 L4 11 L5 6 Z" fill="#f59e0b" />
      <path d="M8 4 L10 8 L10 11 L6 11 L6 8 Z" fill="#ef4444" />
      <rect x="7" y="8" width="2" height="3" fill="#fde047" />
    </g>
    <rect x="4" y="11" width="8" height="2" fill="#7c2d12" />
  </svg>
);

const Skull = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <rect x="3" y="2" width="10" height="8" rx="1" fill="#e5e7eb" />
    <rect x="4" y="10" width="8" height="2" fill="#e5e7eb" />
    <rect x="5" y="12" width="1.4" height="1.6" fill="#e5e7eb" />
    <rect x="7.3" y="12" width="1.4" height="1.6" fill="#e5e7eb" />
    <rect x="9.6" y="12" width="1.4" height="1.6" fill="#e5e7eb" />
    <g style={smooth("wv-eye-glow", 1.4)}>
      <rect x="5" y="5" width="2.2" height="2.4" fill="#ef4444" />
      <rect x="8.8" y="5" width="2.2" height="2.4" fill="#ef4444" />
    </g>
  </svg>
);

const Ghost = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <g style={smooth("wv-float-y", 2.4, { transformOrigin: "center" })}>
      <path d="M3 8 a5 5 0 0 1 10 0 L13 13 L11 11 L9 13 L7 11 L5 13 L3 11 Z" fill="#e5e7eb" opacity="0.92" />
      <rect x="5.5" y="6" width="1.8" height="2.4" fill="#0a0a0c" />
      <rect x="9" y="6" width="1.8" height="2.4" fill="#0a0a0c" />
    </g>
  </svg>
);

const Snow = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <rect x="3" y="2" width="10" height="3" fill="#38bdf8" opacity="0.5" />
    {[3, 7.5, 11].map((x) => (
      <rect
        key={x}
        x={x}
        y="4"
        width="2"
        height="2"
        fill="#e0f2fe"
        style={smooth("wv-snow-fall", 2.6, { animationDelay: `${x * 0.18}s` })}
      />
    ))}
  </svg>
);

const Pirate = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <g style={smooth("wv-sway", 2.2, { transformOrigin: "center" })}>
      <rect x="3" y="2" width="10" height="8" rx="1" fill="#e5e7eb" />
      <rect x="4" y="10" width="8" height="2" fill="#e5e7eb" />
      <rect x="8.8" y="5" width="2.2" height="2.4" fill="#111827" />
      <rect x="2" y="4.5" width="12" height="1.2" fill="#111827" transform="rotate(-12 8 5)" />
      <rect x="5" y="5" width="2.2" height="2.4" fill="#0a0a0c" />
    </g>
  </svg>
);

const Bat = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <rect x="6.5" y="6" width="3" height="4" rx="1" fill="#111827" />
    <rect x="6" y="4.5" width="1.4" height="1.6" fill="#111827" />
    <rect x="8.6" y="4.5" width="1.4" height="1.6" fill="#111827" />
    <path d="M6.5 6 L1 4 L2 9 L6.5 9 Z" fill="#1f2937" style={smooth("wv-flap", 0.7, { transformOrigin: "right" })} />
    <path d="M9.5 6 L15 4 L14 9 L9.5 9 Z" fill="#1f2937" style={smooth("wv-flap", 0.7, { transformOrigin: "left" })} />
    <rect x="7" y="6.4" width="0.8" height="0.8" fill="#ef4444" />
    <rect x="8.2" y="6.4" width="0.8" height="0.8" fill="#ef4444" />
  </svg>
);

const Coin = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <g style={smooth("wv-spin-coin", 1.4, { transformOrigin: "center" })}>
      <rect x="4" y="2" width="8" height="12" rx="2" fill="#f59e0b" />
      <rect x="5" y="3" width="6" height="10" rx="2" fill="#fbbf24" />
      <rect x="7" y="5" width="2" height="6" fill="#b45309" />
    </g>
  </svg>
);

const Western = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <g style={smooth("wv-sway", 2.6, { transformOrigin: "center" })}>
      <rect x="2" y="9" width="12" height="2" rx="1" fill="#78350f" />
      <path d="M5 9 L5 5 Q8 3 11 5 L11 9 Z" fill="#92400e" />
      <rect x="5" y="7.5" width="6" height="1.2" fill="#451a03" />
    </g>
    <rect x="3" y="6" width="3" height="1" fill="#fde047" style={smooth("wv-shine", 2.2)} />
  </svg>
);

const Dice = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <g style={smooth("wv-pulse-scale", 1.3, { transformOrigin: "center" })}>
      <rect x="3" y="3" width="10" height="10" rx="2" fill="#e5e7eb" />
      <rect x="5" y="5" width="1.8" height="1.8" fill="#ef4444" />
      <rect x="9.2" y="5" width="1.8" height="1.8" fill="#ef4444" />
      <rect x="7.1" y="7.1" width="1.8" height="1.8" fill="#ef4444" />
      <rect x="5" y="9.2" width="1.8" height="1.8" fill="#ef4444" />
      <rect x="9.2" y="9.2" width="1.8" height="1.8" fill="#ef4444" />
    </g>
  </svg>
);

const Helmet = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <path d="M2 9 Q2 4 8 4 Q14 4 14 9 L14 10 L2 10 Z" fill="#3f6212" />
    <rect x="2" y="10" width="12" height="1.6" fill="#365314" />
    <rect x="3" y="6" width="4" height="1.2" fill="#a3e635" style={smooth("wv-shine", 2.4)} />
  </svg>
);

const Cursor = () => (
  <svg viewBox="0 0 16 16" width="100%" height="100%">
    <rect x="2" y="4" width="2.2" height="2.2" fill="#84cc16" />
    <rect x="4.2" y="6.2" width="2.2" height="2.2" fill="#84cc16" />
    <rect x="2" y="8.4" width="2.2" height="2.2" fill="#84cc16" />
    <rect x="8" y="4" width="5" height="8" fill="#84cc16" style={anim("wv-blink-cursor", 1.1)} />
  </svg>
);

const MOTIFS = {
  blood: Blood,
  alien: Alien,
  square: SquareGuy,
  flame: Flame,
  skull: Skull,
  ghost: Ghost,
  snow: Snow,
  pirate: Pirate,
  bat: Bat,
  coin: Coin,
  western: Western,
  dice: Dice,
  helmet: Helmet,
  cursor: Cursor,
};

const MOD_MOTIF = {
  "brutal-doom": "blood",
  "project-brutality": "blood",
  "nuts-wad": "blood",
  "myhouse-pk3": "ghost",
  "total-chaos": "ghost",
  "ancient-aliens": "alien",
  "alien-vendetta": "alien",
  "adventures-of-square": "square",
  sigil: "flame",
  sunlust: "flame",
  "hell-revealed": "flame",
  "speed-of-doom": "flame",
  hellbound: "flame",
  guncaster: "flame",
  "hedon-bloodrite": "flame",
  "doom-zero": "skull",
  scythe: "skull",
  "going-down": "skull",
  "plutonia-2": "skull",
  valiant: "skull",
  "deus-vult-2": "skull",
  "struggle-antaresian": "skull",
  "tnt-revilution": "skull",
  "back-to-saturn-x": "skull",
  "doom-64-retribution": "skull",
  "final-doomer": "skull",
  "beautiful-doom": "skull",
  "complex-doom": "skull",
  eviternity: "snow",
  elementalism: "snow",
  "lost-civilization": "snow",
  "pirate-doom": "pirate",
  "batman-doom": "bat",
  "golden-souls-2": "coin",
  "high-noon-drifter": "western",
  "reelism-2": "dice",
  "doomrl-arsenal": "dice",
  "blade-of-agony": "helmet",
  "ashes-2063": "helmet",
};

const fallbackMotif = (mod) => {
  if (mod?.source === "auto") return "cursor";
  const tags = (mod?.tags || []).join(" ").toLowerCase();
  const cat = (mod?.category || "").toLowerCase();
  if (/gore|blood/.test(tags)) return "blood";
  if (/alien/.test(tags)) return "alien";
  if (/horror|liminal/.test(tags)) return "ghost";
  if (/ice|snow|element/.test(tags)) return "snow";
  if (cat.includes("gameplay")) return "skull";
  return "flame";
};

export const getMotifKey = (mod) => MOD_MOTIF[mod?.id] || fallbackMotif(mod);

export const TitleAnimation = ({ mod, size = 40, className = "" }) => {
  const Motif = MOTIFS[getMotifKey(mod)] || Skull;
  return (
    <span
      data-testid={`title-anim-${mod?.id}`}
      className={`wv-anim inline-block shrink-0 ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <Motif />
    </span>
  );
};
